<div class="font-bold mb-3" style="font-size: 1.2rem">{{ 'menu.taxonomy' | translate}}</div>

<p-card>
  <div class="grid">
    <div class="lg:col-3 md:col-4 sm:col-4">
      <p-select
        (onChange)="filterChannel()"
        optionLabel="channelName"
        [options]="channels"
        [(ngModel)]="selectedChannel"
        class="w-full">
        <ng-template let-option pTemplate="item">
          {{ option.channelName | translate }}
        </ng-template>
        <ng-template let-selectedItem pTemplate="selectedItem">
          @if (selectedItem) {
            <p class="inline line-height-1">{{ "global.distributionChannel" | translate }} - </p>
            <p class="inline font-bold line-height-1">{{ selectedItem.channelName | translate}}</p>
          }
        </ng-template>
      </p-select>
    </div>
    @if (locales?.length > 1) {
      <div class="lg:col-2 md:col-3 sm:col-4">
        <p-select
          [(ngModel)]="selectedLocale"
          [options]="locales"
          class="w-full"
          (onChange)="updateLocale()">
        </p-select>
      </div>
    }
  </div>
<p-tabs [value]="0">
  <p-tablist>
    @for (tab of tabs; track $index) {
      <p-tab [value]="$index">{{ tab.label | translate }}</p-tab>
    }
  </p-tablist>

  <p-tabpanels>
    @for (tab of tabs; track $index) {
      <p-tabpanel [value]="$index">
        @if (tab.componentTxt == "category") {
          <app-taxonomy-categories
            [categories]="categories"
            [selectedLocale]="selectedLocale"
            #taxonomyCategory>
          </app-taxonomy-categories>
        } @else {
          <app-taxonomy-attributes
            [categories]="categoriesAttribute"
            [selectedLocale]="selectedLocale"
            #taxonomyAttribute>
          </app-taxonomy-attributes>
        }
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
</p-card>
